export const topicTags = [
  { id: "all", label: "全部话题", count: 1286 },
  { id: "hot", label: "今日热瓜", count: 128 },
  { id: "star", label: "明星动态", count: 342 },
  { id: "circle", label: "圈内爆料", count: 276 },
  { id: "variety", label: "综艺现场", count: 158 },
  { id: "film", label: "影视幕后", count: 203 },
  { id: "review", label: "网友复盘", count: 83 },
];

export const hotKeywords = [
  "最新地址",
  "官网入口",
  "app下载",
  "线路状态",
  "备用网址",
  "今日更新",
  "话题墙",
  "收藏防走丢",
  "移动端优选",
  "秒开线路",
];